import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map.js';
import { actions, selectors } from './';
import { selectors as accountSelectors } from '../account';
import { connect } from '../store/connect';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-grid';
import './confirm-delete-device-btn';
import { AUTHORIZATIONS } from '../authorizations/authorizations';
import { formatDateTime } from '../util/data-helpers';
const { CAN_VERIFY_USER_DEVICES, CAN_SEE_USER_DEVICES } = AUTHORIZATIONS;

class UserDevices extends LitElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex: 1;
                    flex-flow: column;
                }
                :host([hidden]) {
                    display: none;
                }
                .device-row {
                    display: flex;
                    border: 1px solid rgb(0, 0, 0, 0.25);
                    border-radius: 8px;
                    background-color: var(--app-surface-color);
                    min-height: 45px;
                    margin: 4px;
                    align-items: center;
                }
                .cell {
                    display: flex;
                    padding: 6px;
                    align-items: center;
                }
                .cell.name {
                    font-weight: 600;
                }
                .device-action {
                    background-color: var(--app-surface-color);
                    padding: 16px;
                }
                .device-action > div {
                    margin-bottom: 12px;
                }
                tmn-icon[icon='verified_user'] {
                    color: var(--app-success-color);
                }
                tmn-icon[icon='remove_moderator'] {
                    /* color: #ffe5b4; */
                    color: #f66308;
                }
                .cell.full {
                    flex: auto;
                }
                .control-row {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    align-items: center;
                    justify-content: flex-start;
                    margin: 0;
                    padding: 0;
                    margin-bottom: -8px;
                }
            `,
        ];
    }

    static get properties() {
        return {
            devices: {
                type: Array,
            },
            authorizations: {
                type: Array,
            },
            eUserId: {
                type: String,
            },
            eSiteId: {
                type: String,
            },
        };
    }

    updated(changedProps) {
        if (changedProps.has('eUserId')) {
            const { eUserId, authorizations, eSiteId } = this;
            if (authorizations.includes(CAN_SEE_USER_DEVICES)) {
                if (eUserId && eSiteId) {
                    this.actions.fetchUserDevices({ eSiteId, eUserId });
                }
            }
        }
    }

    render() {
        return html`
            <h2>Registered devices</h2>
            <div>${this.renderDeviceList()}</div>
        `;
    }

    renderDeviceList() {
        const { devices = [], authorizations } = this;

        return html`
            <tmn-grid
                container
                direction="column"
                justify="center"
                alignContent="center"
                spacing="2">
                ${devices.map((device, i) => {
                    const unverified = !device.isVerified;
                    const showVerifyButton =
                        unverified && authorizations.includes(CAN_VERIFY_USER_DEVICES);
                    const showRemoveButton = authorizations.includes(CAN_VERIFY_USER_DEVICES);
                    const classes = classMap({ 'device-row': true, unverified });
                    return html`<tmn-grid
                        class="${classes}"
                        container
                        item
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        spacing="1">
                        <div class="data cell name">${device.name}</div>
                        <div class="data cell">
                            <i>Last visit</i>: ${formatDateTime(device.last_visit)}
                        </div>
                        <div class="data cell full">
                            <i>Last verified</i>:
                            ${formatDateTime(device.last_verified, 'NONE')}
                        </div>
                        <div class="data cell full">${device.agent} | ${device.location}</div>
                        <div class="control-row">
                            <div class="control cell device-icon">
                                ${device.isVerified
                                    ? html`<tmn-icon icon="verified_user"></tmn-icon>`
                                    : html`<tmn-icon icon="remove_moderator"></tmn-icon>`}
                            </div>
                            ${showVerifyButton
                                ? html`<div class="control cell">
                                      <tmn-button @click=${this.handleVerify} .value=${device.id}>
                                          <tmn-icon
                                              slot="startIcon"
                                              color="primary"
                                              iconvariant="outlined"
                                              icon="check"></tmn-icon>
                                          Verify Device
                                      </tmn-button>
                                  </div>`
                                : null}
                            ${showRemoveButton
                                ? html`<div class="control cell">
                                      <confirm-delete-device-btn
                                          @delete-device-confirmed=${this.handleRemove}
                                          .eventData=${{ value: device.id }}
                                          .actionLabel=${'Remove'}></confirm-delete-device-btn>
                                  </div>`
                                : null}
                        </div>
                    </tmn-grid> `;
                })}
            </tmn-grid>
        `;
    }

    handleVerify(e) {
        const { eUserId, eSiteId } = this;
        const { value } = e.detail;
        this.actions.verifyDevice({ eUserId, eSiteId, deviceId: value });
    }

    handleRemove(e) {
        const { eUserId, eSiteId } = this;
        const { value } = e.detail;
        this.actions.removeDevice({ eUserId, eSiteId, deviceId: value });
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        const userData = selectors.selectedUserDataSelector(state);
        return {
            eUserId: userData?.eUserId,
            eSiteId: userData?.eSiteId,
            authorizations: accountSelectors.accountAuthorizationsSelector(state),
            devices: selectors.userDevicesSelector(state),
        };
    };
};

const combinedActions = {
    ...actions,
};

customElements.define('user-devices', connect(mapStateToProps, combinedActions)(UserDevices));
